/**
 * smooth scrolling
 */

$(() => {
    $('a[href*="#"]:not([href="#"])').click(function () {
        if (location.pathname.replace(/^\//, '') == this.pathname.replace(/^\//, '') && location.hostname == this.hostname) {
            let target = $(this.hash);
            target = target.length ? target : $(`[name=${this.hash.slice(1)}]`);
            if (target.length && this.hash !== '#intro') {
                $('html, body').animate({
                    scrollTop: ((target.offset().top) - 40),
                }, 1000);
                return false;
            }
            $('html, body').animate({
                scrollTop: 0,
            }, 1000);
            return false;
        }
    });
});

